import React, {useEffect, useState} from "react";
import {getLimitedSearchResults} from "../service/api";
import {SearchResultItem} from "./SearchResultItem";
import {SearchResult} from "../types/searchResult";
import {useTranslation} from "../hooks/useTranslation";

type RecommendationsProps = {
    searchText : string,
    searchResultLink: string,
}

export function SearchSuggestions({searchText, searchResultLink}: RecommendationsProps) {

    const [suggestions, setSuggestions] = useState<SearchResult[]>([]);

    const translate = useTranslation();

    useEffect(()=> {
        if(searchText) {
            getLimitedSearchResults(searchText).then(response => {
                setSuggestions(response.items);
            });
        } else {
            setSuggestions([])
        }

    }, [searchText]);

    return (
        <div className='search__suggestion col-12 col-lg-8'>
            <div className='search__suggestion--title'>{translate('search.suggestion.title')}</div>

            {suggestions && suggestions.map((item) => <SearchResultItem item={item}/>)}

            <div className='search__suggestion--allResults'>
                <a className='btn btn--variant-text-icon' href={searchResultLink + '?search=' + searchText} aria-label={translate('search.show.all.results')}>
                    {translate('search.show.all.results')}
                </a>
            </div>
        </div>
    );
}
